import { LuArrowDown, LuArrowUp, LuArrowLeftRight, LuArrowLeftFromLine, LuArrowRightToLine } from 'react-icons/lu';
import { VscSymbolInterface } from 'react-icons/vsc';

export const FlowInGlyph = () => <LuArrowDown />;
export const FlowOutGlyph = () => <LuArrowDown />;
export const DataGlyph = () => <LuArrowLeftRight />;
export const ProviderGlyph = () => <VscSymbolInterface />;
export const ArrowLeftGlyph = () => <LuArrowLeftFromLine />;
export const ArrowRightGlyph = () => <LuArrowRightToLine />;
export const FlowUpGlyph = () => <LuArrowUp />;
